export const PROFILE = '/profile'
export const AUTH = '/authorization'
export const REG = '/registration'
export const SELECTION = '/selections'
export const SEARCH = '/search'
export const ARTICLES  = '/selection'
export const MAIN = '/'
export const CITATION = "/selection/reading-trajectories"
export const GRAPHS = "/graphs"
export const SUMM = "/summarization"